import { SignalWatcher, WithDisposable } from '@blocksuite/affine/global/lit';
import { ShadowlessElement } from '@blocksuite/affine/std';
import { CodeBlockIcon } from '@blocksuite/icons/lit';
import { html } from 'lit';
import { property } from 'lit/decorators.js';

import type { CodeSelectionAttachment } from '../ai-chat-content/type';

export class ChatPanelCodeSelectionChip extends SignalWatcher(
  WithDisposable(ShadowlessElement)
) {
  @property({ attribute: false })
  accessor codeSelection!: CodeSelectionAttachment;

  @property({ attribute: false })
  accessor onRemove: ((selection: CodeSelectionAttachment) => void) | undefined;

  override render() {
    const { codeSelection } = this;
    const lines =
      codeSelection.fromLine === codeSelection.toLine
        ? `L${codeSelection.fromLine}`
        : `L${codeSelection.fromLine}-L${codeSelection.toLine}`;
    const label = `${codeSelection.title} · ${lines}`;

    return html`<chat-panel-chip
      .state=${'finished'}
      .name=${label}
      .tooltip=${this._getTooltip()}
      .icon=${CodeBlockIcon()}
      .closeable=${!!this.onRemove}
      .onChipDelete=${this._handleRemove}
    ></chat-panel-chip>`;
  }

  private _getTooltip(): string {
    const { title, language, surface, fromLine, toLine, selectedText } =
      this.codeSelection;
    const lines =
      fromLine === toLine ? `line ${fromLine}` : `lines ${fromLine}-${toLine}`;
    return [
      `Code: ${title}`,
      `Surface: ${surface}`,
      `Language: ${language}`,
      `Selection: ${lines}`,
      selectedText,
    ].join('\n');
  }

  private readonly _handleRemove = () => {
    this.onRemove?.(this.codeSelection);
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'chat-panel-code-selection-chip': ChatPanelCodeSelectionChip;
  }
}
